
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        message: {
            home: 'Website homepage',
            scope:'Business scope',
            service:'Service content',
            partners:'Partners',
            contact:'Contact us',
            myService:"The products we offer",
            excellentPartners:"Excellent partners",
            address:"Company address",
            phone:"Contact phone number"
        }
    },
    zh: {
        message: {
            home: '网站首页',
            scope: '业务范围',
            service:'服务内容',
            partners:'合作伙伴',
            contact:'联系我们',
            myService:"我们提供的产品",
            excellentPartners:"优秀的合作伙伴",
            address:"公司地址",
            phone:"联系电话"
        }
    }
};

const i18n = new VueI18n({
    locale: 'zh', // 默认语言
    messages,
});

export default i18n;